module.exports = "<span class=\"c-single-tag__bar\">\n  <span *ngIf=\"icon\" class=\"c-tag-group__icon\"><i class=\"icon__n icon__n--{{icon}}\"</span>\n  <span class=\"c-single-tag__label\"\n    [innerHTML]=\"data?.name\"></span>\n  <span *ngIf=\"data?.name && action?.icon && !isDisabled\" class=\"c-single-tag__action\">\n    <app-button (click)=\"emitAction(action?.name)\" type=\"icon\" [icon]=\"action?.icon\" theme=\"secondary\"></app-button>\n  </span>\n</span>"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/components/single-tag/single-tag.component.html
// module id = ./src/app/modules/common-module/components/single-tag/single-tag.component.html
// module chunks = 9